// @mui
import type { Theme } from '@mui/material/styles';

import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

//
import type { LabelColor, LabelVariant } from './types';

// ----------------------------------------------------------------------

export const StyledLabel = styled(Box)(({
  ownerState,
  theme,
}: {
  ownerState: {
    color: LabelColor;
    variant: LabelVariant;
  };
  theme: Theme;
}) => {
  const isLight = theme.palette.mode === 'light';

  const filledVariant = ownerState.variant === 'filled';

  const outlinedVariant = ownerState.variant === 'outlined';

  const softVariant = ownerState.variant === 'soft';

  const defaultStyle = {
    ...(ownerState.color === 'default' && {
      // OUTLINED
      ...(outlinedVariant && {
        backgroundColor: 'transparent',
        border: `1px solid ${alpha(theme.palette.grey[500], 0.32)}`,
        color: theme.palette.text.primary,
      }),
      // SOFT
      ...(softVariant && {
        backgroundColor: alpha(theme.palette.grey[500], 0.16),
        color: isLight
          ? theme.palette.text.primary
          : theme.palette.common.white,
      }),
    }),
  };

  const colorStyle = {
    ...(ownerState.color !== 'default' && {
      // FILLED
      ...(filledVariant && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText,
      }),
      // OUTLINED
      ...(outlinedVariant && {
        backgroundColor: 'transparent',
        border: `1px solid ${theme.palette[ownerState.color].main}`,
        color: theme.palette[ownerState.color].main,
      }),
      // SOFT
      ...(softVariant && {
        backgroundColor: alpha(theme.palette[ownerState.color].main, 0.16),
        color: theme.palette[ownerState.color][isLight ? 'dark' : 'light'],
      }),
    }),
  };

  return {
    alignItems: 'center',
    backgroundColor: theme.palette.grey[300],
    borderRadius: 6,
    color: theme.palette.grey[800],
    cursor: 'default',
    display: 'inline-flex',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightBold,
    height: 24,
    justifyContent: 'center',
    lineHeight: 0,
    minWidth: 22,
    padding: theme.spacing(0, 1),
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    ...colorStyle,
    ...defaultStyle,
  };
});
